import { motion } from "framer-motion";
import { Users, Target, ShieldCheck } from "lucide-react";

const PILLARS = [
  {
    Icon: Users,
    headline: "Eight executives. One company.",
    body: "Every key role staffed by a domain-specialized AI agent that learns your company's context.",
    accent: "bg-violet-50 text-violet-700",
  },
  {
    Icon: Target,
    headline: "Decisions, not chatter.",
    body: "Boardroom debates end in a recommendation with confidence, strategy, and risk — not a wall of chat.",
    accent: "bg-cyan-50 text-cyan-700",
  },
  {
    Icon: ShieldCheck,
    headline: "You stay in command.",
    body: "Anything that needs human judgment is flagged with step-by-step instructions and a one-click fix path.",
    accent: "bg-orange-100 text-orange-700",
  },
];

export default function ValuePillars() {
  return (
    <section
      data-testid="value-pillars"
      id="product"
      className="px-5 py-24 md:px-8 md:py-32"
    >
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="mb-14 max-w-2xl"
        >
          <div className="eyebrow">Why Idea AI</div>
          <h2 className="mt-3 text-[40px] font-black leading-[1.02] tracking-tight text-zinc-900 md:text-[56px]">
            A real exec team —<br />
            with zero overhead.
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.25 }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08 } },
          }}
          className="grid grid-cols-1 gap-5 md:grid-cols-3"
        >
          {PILLARS.map(({ Icon, headline, body, accent }, i) => (
            <motion.div
              key={i}
              data-testid={`pillar-${i}`}
              variants={{
                hidden: { opacity: 0, y: 18 },
                show: {
                  opacity: 1,
                  y: 0,
                  transition: { type: "spring", stiffness: 120, damping: 18 },
                },
              }}
              className="card-soft flex flex-col gap-4 rounded-[28px] p-7"
            >
              <div
                className={`flex h-12 w-12 items-center justify-center rounded-2xl ${accent}`}
              >
                <Icon className="h-5 w-5" strokeWidth={2.2} />
              </div>
              <h3 className="text-[22px] font-extrabold leading-tight tracking-tight text-zinc-900">
                {headline}
              </h3>
              <p className="text-[14px] leading-relaxed text-zinc-600">
                {body}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
